import { RefObject, useEffect } from 'react';

/**
 * Hook to add a custom onreset function to the form reset behaviour.
 * use this when components need reset state when form reset is called.
 */
export function useOnFormReset(formRef: RefObject<HTMLFormElement | null>, onReset: () => any) {
  useEffect(() => {
    const formElement = formRef.current;
    if (formElement) {
      formElement.addEventListener('reset', onReset);
      return () => {
        formElement.removeEventListener('reset', onReset);
      };
    }
  }, [formRef, onReset]);
}
